import type { Connection, PublicKey } from '@solana/web3.js';
import { CP_SWAP_PROGRAM_ID } from '../constants/programs.js';
import { getCpSwapProgram } from '../idl/loader.js';
import type { PoolStateAccount } from './cp-swap-types.js';

/** Decode already fetched pool data with the same current IDL coder used by fetchPoolState; no RPC. */
export async function decodePoolState(
  connection: Connection,
  data: Buffer,
  programId: PublicKey = CP_SWAP_PROGRAM_ID,
): Promise<PoolStateAccount> {
  const program = await getCpSwapProgram(connection, programId);
  return program.coder.accounts.decode<PoolStateAccount>('poolState', data);
}
